.labelStyle {
  /* base styles */
}
.labelStyle:focus {
  outline: none;
}

/* Variants from variantStyles */
.labelStyle-primary {
  fill: var(--tractie-color-content-default-inverse);
  font-size: 0.875rem;
  font-weight: 700;
}
.labelStyle-claim {
  fill: var(--tractie-color-content-default);
  font-size: 0.875rem;
  font-weight: 700;
}
.labelStyle-defectInzetbaar {
  fill: var(--mwd-color-treintaak-text-defect-inzetbaar);
  font-size: 0.875rem;
  font-weight: 700;
}
.labelStyle-korteInzet {
  fill: var(--tractie-color-content-subtle);
  font-size: 0.875rem;
  font-weight: 700;
}
